import React from 'react'

function Sermon() {
  return (
    <div>Sermon</div>
  )
}

export default Sermon